import { render, staticRenderFns } from "./ProfileDetails.vue?vue&type=template&id=a93d1bd4&scoped=true"
import script from "./ProfileDetails.vue?vue&type=script&lang=js"
export * from "./ProfileDetails.vue?vue&type=script&lang=js"
import style0 from "./ProfileDetails.vue?vue&type=style&index=0&id=a93d1bd4&prod&scoped=true&lang=css"
import style1 from "./ProfileDetails.vue?vue&type=style&index=1&id=a93d1bd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93d1bd4",
  null
  
)

export default component.exports